import { render } from "./ListeArticle.vue?vue&type=template&id=37e27160&ts=true"
import script from "./ListeArticle.vue?vue&type=script&lang=ts"
export * from "./ListeArticle.vue?vue&type=script&lang=ts"

import "./ListeArticle.vue?vue&type=style&index=0&id=37e27160&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__